var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumb',{attrs:{"path2":_vm.path2}}),_vm._v(" "),_c('div',{staticClass:"terms"},[_c('div',{staticClass:"main-content"},[_c('div',{staticClass:"page-width pre-formatted"},[_c('div',{staticClass:"section-header text-center"},[_c('h1',[_vm._v(_vm._s(_vm.$t('termsTitle')))])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5d4f71c","hasScoped":true,"transformToRequire":{"vue-h-zoom":["image","image-full"]},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/Footer/terms.vue
// module id = null
// module chunks = 